/**
 * Guest users have no backend-assigned percorso, but during onboarding they
 * still pick one. We persist that choice locally so the Menu header can show
 * the chosen path name instead of "N/D". Updated every time the guest selects
 * (or changes) a path.
 */

const GUEST_PATH_KEY = "guestSelectedPath";

export const getGuestSelectedPath = () => {
  try {
    return localStorage.getItem(GUEST_PATH_KEY) || null;
  } catch {
    return null;
  }
};

export const setGuestSelectedPath = (name) => {
  try {
    if (name) {
      localStorage.setItem(GUEST_PATH_KEY, String(name));
    }
  } catch {
    /* ignore storage errors (private mode, quota, etc.) */
  }
};
